import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon, Logout as LogoutIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { LocaleAndThemeToolbar } from "@/components/LocaleAndThemeToolbar";
import { DRAWER_WIDTH } from "./constants";

interface TopBarProps {
  onMenuToggle: () => void;
}

export default function TopBar({ onMenuToggle }: TopBarProps) {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
        ml: { md: `${DRAWER_WIDTH}px` },
      }}
    >
      <Toolbar>
        {!isDesktop && (
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
          {t("app.title")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LocaleAndThemeToolbar variant="appBar" />
          {user && (
            <Typography
              variant="body2"
              onClick={() => navigate("/settings")}
              sx={{
                color: "inherit",
                display: { xs: "none", sm: "block" },
                ml: 1,
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              {user.email}
            </Typography>
          )}
          <Button
            color="inherit"
            size="small"
            startIcon={<LogoutIcon />}
            onClick={logout}
          >
            {t("auth.logout")}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
